// removed by extract-text-webpack-plugin
module.exports = {"view":"src-modules-orders-NewOrderModal-__NewOrderModalView__view--RJpfF","container":"src-modules-orders-NewOrderModal-__NewOrderModalView__container--2CpCJ","header":"src-modules-orders-NewOrderModal-__NewOrderModalView__header--36pDV","content":"src-modules-orders-NewOrderModal-__NewOrderModalView__content--2ci-s","sidebar":"src-modules-orders-NewOrderModal-__NewOrderModalView__sidebar--3UF1_","actions":"src-modules-orders-NewOrderModal-__NewOrderModalView__actions--3BiDi"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/orders/NewOrderModal/NewOrderModalView.less
// module id = 1886
// module chunks = 0